module.exports = __webpack_public_path__ + "static/EGLD-586875c17f8dd292bc1f118afd94f9b1.svg";